import { useEffect } from 'react';
import { getBrandName } from 'utils/helpers';

let { locationName } = window.ecom?.craftConfig;
locationName = locationName?.replace(/&#039;/g, "'");

export function useDocumentTitle(pageTitle) {
  useEffect(() => {
    const brandName = getBrandName();
    if (pageTitle === undefined) {
      // Do nothing here, title will be valid soon
    } else if (pageTitle === 'accommodation') {
      document.title = `Best places to stay in ${locationName} | ${brandName} ${locationName}`;
    } else if (pageTitle === 'default') {
      document.title = `Ferry, Accommodation, Holidays and Tours | ${brandName} ${locationName}`;
    } else {
      document.title = `${pageTitle} | ${brandName} ${locationName}`;
    }
  }, [pageTitle]);
}
